import { Factory, trait } from 'miragejs';

export default Factory.extend({
  active: trait({ status: 'active' }),
  uninstalled: trait({ status: 'uninstalled' }),
  failing: trait({ status: 'failing' }),
  disabled: trait({ status: 'disabled' }),
  pending: trait({ status: 'pending' }),

  asBadgeDrivenProtect: trait({
    config: { eventDrivenProtect: true },
  }),
});
